@if (config()) {
  <div [hidden]="isMobile">
    <cnet-toolbar color="secondary">
      <div class="header-container">
        <div class="img-logo d-flex align-items-center" [routerLink]="''">
          <img class="portal-logo" [src]="config()?.portal.darkLogoUrl" [alt]="config()?.portal.name" />
        </div>

        <div #headerOptions class="d-flex" style="margin-left: auto; overflow: hidden; width: 100vw">
          @for (route of routesHeaderSignal(); track route) {
            <ng-container *ngxPermissionsExcept="route.data.permissions?.except">
              <div #menuOption [hidden]="!route.visible">
                <a
                  type="button"
                  [id]="route.data.name"
                  cnet-button
                  [routerLink]="route.routerLink"
                  *ngxPermissionsOnly="route.data.permissions?.only"
                  class="ml-0 menu-not-mobile btn-options"
                  routerLinkActive="is-active">
                  <cnet-icon [size]="1" style="padding-right: 4px" [name]="route.data.icon" label="route.data.icon" />
                  {{ route.data.name | translate }}
                </a>
              </div>
            </ng-container>
          }
        </div>

        @if (isUserLoggedIn()) {
          @if (routesHeaderBreaks.length) {
            <div
              class="cnet-profile-menu-avatar cnet-bars-menu cnet-profile-responsive-menu m-0"
              [cnet-menu-trigger]="menuOtherOptions">
              <cnet-icon name="bars" />
            </div>
          }

          <!-- notification bell -->
          <div class="cnet-profile-bell" [cnet-notifications-trigger]="cnetNotification">
            <cnet-notifications-bell
              id="cnet-notification-bell"
              #cnetNotification="cnetNotification"
              [size]="noticationsSignal()?.length"
              [idleTime]="300000"
              (click.throttle)="getNotificationClick($event)">
              <div class="box-notification">
                @if (noticationsSignal()?.length) {
                  @for (notification of noticationsSignal(); track notification) {
                    <a
                      cnet-menu-item
                      class="notification-item"
                      [routerLink]="notification.route"
                      [queryParams]="notification.params"
                      (click)="cnetNotification?.hide()">
                      <div [innerHtml]="notification.description | translate: resolveParams(notification)"></div>
                    </a>
                  }
                } @else {
                  <div cnet-menu-item>
                    {{ 'Você não tem notificações' | translate }}
                  </div>
                }
              </div>
            </cnet-notifications-bell>
          </div>

          @if (canShowSettingsButton()) {
            <a
              class="cnet-profile-menu-avatar cnet-profile-responsive-menu m-0"
              [routerLink]="'settings'"
              routerLinkActive="is-active"
              style="color: white; text-decoration: none"
              *ngxPermissionsOnly="[
                'SettingsAgreementModuleAccess',
                'SettingsInternshipModuleAccess',
                'SettingsSystemAccess',
                'SettingsEvaluationModuleAccess',
                'SettingsOpportunityModuleAccess',
                'SettingsDocumentAccess',
                'SettingsInsuranceAccess',
                'SettingsUserPermission',
                'SettingsGroupPermission',
                'SettingsPortalLayoutAccess',
                'InstitutionTeamVisualize',
                'SettingsInternshipImportSummaryAccess',
                'InternshipTokenAesAccess',
                'ApiIntegrationManagementAccess',
                'ImportCoursesConfiguration',
              ]">
              <cnet-icon [size]="2" style="padding-right: 4px" [name]="'cog'" />
            </a>
          }

          <!-- profile-menu   -->

          @if (userDetailsSignal()) {
            <div id="profile-menu-open" class="cnet-profile-menu-avatar m-0" [cnet-menu-trigger]="profileMenu">
              @if (!userDetailsSignal()?.shortName) {
                <cnet-progress-spinner class="loading-img-usu" diameter="20" strokeWidth="2" />
              } @else {
                <cnet-avatar
                  cnet-button
                  class="user-avatar logout dropdown-toggle"
                  size="normal"
                  [src]="userDetailsSignal()?.urlPhoto"
                  [alt]="userDetailsSignal().shortName"
                  [text]="userDetailsSignal().shortName" />
              }
              <cnet-icon name="angle-down" />
            </div>
          }
        } @else {
          <!-- public items  -->
          <span class="public-itens">
            <button
              type="button"
              id="home"
              esater
              cnet-button
              [routerLink]="''"
              class="ml-0 menu-not-mobile btn-options">
              {{ 'home' | translate }}
            </button>

            @if (hasBlog()) {
              <button
                type="button"
                id="blog"
                cnet-button
                class="ml-0"
                (click)="openLink(hasBlog())"
                [routerLink]="hasBlog()">
                {{ 'blog' | translate }}
              </button>
            }

            @if (!hideLoginBtn()) {
              <button
                id="entrar"
                type="button"
                cnet-stroked-button
                size="small"
                [routerLink]="'auth'"
                class="mt-3 ml-4 mb-3 btn-login">
                {{ 'entrar' | translate }}
              </button>
            }

            <div class="language-switcher" *ngIf="showLanguageOption">
              <app-language-switcher></app-language-switcher>
            </div>
          </span>
        }
      </div>
    </cnet-toolbar>

    <cnet-menu #menuOtherOptions="cnetMenu" cnet-remove-on-scroll>
      @for (route of routesHeaderBreaks; track route) {
        <ng-container *ngxPermissionsExcept="route.data.permissions?.except">
          <div>
            <a
              type="button"
              [id]="route.data.name"
              cnet-menu-item
              [routerLink]="route.routerLink"
              *ngxPermissionsOnly="route.data.permissions?.only"
              class="btn-cnet-menu menu-not-mobile"
              (click)="menuOtherOptions.hide()">
              <cnet-icon [name]="route.data.icon" label="route.data.icon"></cnet-icon>
              {{ route.data.name | translate }}
            </a>
          </div>
        </ng-container>
      }
    </cnet-menu>

    <cnet-menu id="profileMenu" class="cnet-profile-menu" cnet-overlay cnet-remove-on-scroll #profileMenu="cnetMenu">
      <app-profile-menu-card
        [menu]="profileMenu"
        [routesProfileMenu]="routesProfileMenuSignal()"
        [userDetails]="userDetailsSignal()" />
    </cnet-menu>
  </div>

  <div [hidden]="!isMobile" #toolbar>
    <cnet-toolbar class="toolbar-mobile" color="secondary">
      @if (isUserLoggedIn()) {
        <span style="display: contents">
          @if (userDetailsSignal()) {
            <div id="cnet-sidenav-open" class="cnet-profile-menu-avatar m-0" [cnet-sidenav-trigger]="sidenav">
              @if (!userDetailsSignal()?.shortName) {
                <cnet-progress-spinner class="loading-img-usu" diameter="20" strokeWidth="2" />
              } @else {
                <cnet-avatar
                  cnet-button
                  class="user-avatar logout dropdown-toggle"
                  size="normal"
                  [src]="userDetailsSignal()?.urlPhoto"
                  [alt]="userDetailsSignal().shortName"
                  [text]="userDetailsSignal().shortName" />
              }
              <cnet-icon name="angle-down" />
            </div>

            <cnet-sidenav #sidenav="cnetSidenav" backdrop-close animationStartPosition="'left'">
              <app-profile-menu-card
                [isMobile]="true"
                [routesProfileMenu]="routesProfileMenuSignal()"
                [userDetails]="userDetailsSignal()" />
            </cnet-sidenav>
          }

          <div [routerLink]="''" class="img-logo img-logo-responsive">
            <img class="portal-logo" [src]="config()?.portal.darkLogoUrl" [alt]="config()?.portal.name" />
          </div>

          <div class="cnet-profile-bell" [cnet-notifications-trigger]="cnetNotification" style="margin-left: 0">
            <cnet-notifications-bell
              id="cnet-notification-bell"
              #cnetNotification="cnetNotification"
              [size]="noticationsSignal()?.length"
              [idleTime]="300000"
              (click.throttle)="getNotificationClick($event)">
              <div class="box-notification">
                @if (noticationsSignal()?.length) {
                  @for (notification of noticationsSignal(); track notification) {
                    <a
                      cnet-menu-item
                      class="notification-item"
                      [routerLink]="notification.route"
                      [queryParams]="notification.params"
                      (click)="cnetNotification?.hide()">
                      <div [innerHtml]="notification.description | translate: resolveParams(notification)"></div>
                    </a>
                  }
                } @else {
                  <div cnet-menu-item>
                    {{ 'Você não tem notificações' | translate }}
                  </div>
                }
              </div>
            </cnet-notifications-bell>
          </div>
          @if (canShowSettingsButton()) {
            <a
              style="width: 54px"
              class="cnet-profile-menu-avatar cnet-profile-responsive-menu m-0"
              [routerLink]="'settings'"
              routerLinkActive="is-active"
              style="color: white; text-decoration: none"
              *ngxPermissionsOnly="[
                'SettingsAgreementModuleAccess',
                'SettingsInternshipModuleAccess',
                'SettingsSystemAccess',
                'SettingsEvaluationModuleAccess',
                'SettingsOpportunityModuleAccess',
                'SettingsDocumentAccess',
                'SettingsInsuranceAccess',
                'SettingsUserPermission',
                'SettingsGroupPermission',
                'SettingsPortalLayoutAccess',
                'InstitutionTeamVisualize',
                'SettingsInternshipImportSummaryAccess',
                'InternshipTokenAesAccess',
                'ApiIntegrationManagementAccess',
                'ImportCoursesConfiguration',
              ]">
              <cnet-icon [size]="2" style="padding-right: 4px" [name]="'cog'" />
            </a>
          }
        </span>
      } @else {
        <div class="img-logo" [routerLink]="''">
          <img class="portal-logo" [src]="config()?.portal.darkLogoUrl" [alt]="config()?.portal.name" />
        </div>

        <div class="m-0" [cnet-sidenav-trigger]="cnetSidenavLogedOut">
          <cnet-icon name="bars" />
        </div>
      }
    </cnet-toolbar>

    @if (isUserLoggedIn()) {
      <cnet-toolbar class="toolbar-mobile toolbar-mobile-navigation" color="secondary">
        <div
          #headerOptionsMobile
          class="d-flex flex-row justify-content-center"
          style="margin-left: auto; overflow: hidden; width: 100vw">
          @for (route of routesHeaderSignal(); track route) {
            <ng-container *ngxPermissionsExcept="route.data.permissions?.except">
              @if (route.visible) {
                <div #menuMobileOption>
                  <button
                    [id]="route.data.name"
                    type="button"
                    cnet-button
                    [routerLink]="route.routerLink"
                    routerLinkActive="is-active"
                    *ngxPermissionsOnly="route.data.permissions?.only"
                    class="ml-0 btn-options responsive-button"
                    (click)="menuOtherOptions.hide()">
                    <div class="responsive-button-content">
                      <cnet-icon [name]="route.data.icon" label="route.data.icon" />
                      <div class="label-btn-mobile">
                        {{ route.data.name | translate }}
                      </div>
                    </div>
                  </button>
                </div>
              }
            </ng-container>
          }

          @if (routesHeaderBreaks.length) {
            <div
              id="cnet-profile-menu-open"
              style="width: 54px"
              class="cnet-profile-menu-avatar cnet-profile-responsive-menu m-0"
              [cnet-menu-trigger]="menuOtherOptions">
              <cnet-icon name="bars" />
            </div>
          }
        </div>
      </cnet-toolbar>
    }

    <cnet-sidenav
      [hidden]="true"
      #cnetSidenavLogedOut="cnetSidenav"
      backdrop-close
      [elementRef]="toolbar"
      [hasBackdrop]="false"
      animationStartPosition="right">
      <app-sandwitch-menu>
        <button type="button" id="home" cnet-button [routerLink]="'/'" class="ml-0 btn-options" cnet-sidenav-close>
          {{ 'home' | translate }}
        </button>

        @if (hasBlog()) {
          <button
            id="blog"
            type="button"
            cnet-button
            class="ml-0"
            (click)="openLink(hasBlog())"
            [routerLink]="hasBlog()"
            cnet-sidenav-close>
            {{ 'blog' | translate }}
          </button>
        }
        <div id="language-switcher" class="language-switcher" *ngIf="showLanguageOption">
          <app-language-switcher></app-language-switcher>
        </div>

        @if (!hideLoginBtn()) {
          <button
            id="entrar"
            type="button"
            cnet-button
            cnet-filled-button
            class="ml-0 btn-options"
            [routerLink]="'auth'"
            cnet-sidenav-close
            color="primary">
            {{ 'entrar' | translate }}
          </button>
        }
      </app-sandwitch-menu>
    </cnet-sidenav>
  </div>
}
